export enum WorkHistoryExternalObjectType {
  GITHUB_PULL_REQUEST = "github_pull_request",
  JIRA_ISSUE = "jira_issue",
  HUBSPOT_DEAL = "hubspot_deal",
  SALESFORCE_ACTIVITY = "salesforce_activity",
  LINEAR_ISSUE = "linear_issue",
  LINEAR_PROJECT = "linear_project",
}

export const WorkHistoryExternalObjectTitles: {
  [key: string]: string;
} = {
  [WorkHistoryExternalObjectType.GITHUB_PULL_REQUEST]: "Github",
  [WorkHistoryExternalObjectType.JIRA_ISSUE]: "JIRA",
  [WorkHistoryExternalObjectType.HUBSPOT_DEAL]: "Hubspot",
  [WorkHistoryExternalObjectType.SALESFORCE_ACTIVITY]: "Salesforce",
  [WorkHistoryExternalObjectType.LINEAR_ISSUE]: "Linear",
  [WorkHistoryExternalObjectType.LINEAR_PROJECT]: "Linear",
};

export type BasicExternalEvent = {
  id: string;
  title: string;
  url: string;
};

export type GithubPullRequestEventObject = BasicExternalEvent & {
  type: WorkHistoryExternalObjectType.GITHUB_PULL_REQUEST;
};
export type JiraIssueEventObject = BasicExternalEvent & {
  type: WorkHistoryExternalObjectType.JIRA_ISSUE;
};
export type HubspotDealEventObject = BasicExternalEvent & {
  type: WorkHistoryExternalObjectType.HUBSPOT_DEAL;
  status: "Open" | "Closed";
  stage: string;
  won: boolean;
  amount: number;
  engagements: { id: string; type: "email" | "call" }[];
};
export type LinearIssueEventObject = BasicExternalEvent & {
  type: WorkHistoryExternalObjectType.LINEAR_ISSUE;
};
export type LinearProjectEventObject = BasicExternalEvent & {
  type: WorkHistoryExternalObjectType.LINEAR_PROJECT;
  is_lead: boolean;
  is_member: boolean;
};

export type WorkHistoryExternalEventObject =
  | GithubPullRequestEventObject
  | JiraIssueEventObject
  | HubspotDealEventObject
  | LinearIssueEventObject
  | LinearProjectEventObject;
